import { Typography, Grid } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface CustomerBirthdayProps {
    customerData: CustomerInterface
}

const CustomerBirthday: React.FC<CustomerBirthdayProps> = ({
    customerData
}) => {
    return (
        <Grid container>
            <Grid item xs={12}>
                <Typography variant="caption" sx={{color: "#333399"}}>生年月日</Typography>
            </Grid>
            <Grid item>
                <Typography variant="body1">{(customerData.ctm_birthday && customerData.ctm_birthday !== "0000-00-00") ? format(new Date(customerData.ctm_birthday), "yyyy年MM月dd日")  : "未入力"}</Typography>
            </Grid>
        </Grid>
    );
}

export default CustomerBirthday